import { useWindowStore } from './store';
import css from './Window.module.css';

/**
 * A transparent sheet raised over the whole desktop for the duration of a drag
 * or resize.
 *
 * Pointer capture alone isn't enough: an <iframe> is a separate document, and
 * the moment the cursor crosses one it can eat the pointer stream and strand
 * the window mid-move. Covering everything with one inert div keeps every
 * event in this document. `global.css` disables iframe pointer events during
 * an interaction as a second line of defence.
 */
export function IframeShield() {
  const interacting = useWindowStore((s) => s.interacting);
  const nextZ = useWindowStore((s) => s.nextZ);

  if (!interacting) return null;

  return <div className={css.shield} style={{ zIndex: nextZ + 1 }} aria-hidden="true" />;
}
